<template>
  <span class="clickeable">
    <span v-show="showGeo"
          class="fa-stack fa-2x"
          @click="goGeocode">
                <i class="fas fa-map-marked-alt fa-stack-2x"/>
                <i class="fas fa-map-marker-alt fa-stack-1x point-map"/>
    </span>
  </span>
</template>

<script>
import { geoUpdateHandler, manageSession } from '../../../../mixins/manageSession';

export default {
  props: {
    value: {
      type: Number,
      default: 0,
    },
    suborder: {
      type: Number,
      default: 0,
    },
  },
  name: 'GoGeo',
  data() {
    return {
      open: false,
      geoState: this.value,
    };
  },
  watch: {
    value() {
      this.geoState = this.value;
    },
    open() {
      if (window.addEventListener && this.open) {
        window.addEventListener('storage', geoUpdateHandler(() => {
          this.geoState = 99;
          this.$emit('input', this.geoState);
          this.$emit('action');
          this.open = false;
          if (this.newPage) this.newPage.close();
        }), false);
      }
    },
  },
  methods: {
    goGeocode() {
      const routeData = this.$router.resolve({ name: 'Geocode', query: { v: 'fromSubs' } });
      sessionStorage.setItem('suborders', JSON.stringify([this.suborder]));
      manageSession();
      window.name = 'geosortMain';
      this.open = true;
      this.newPage = window.open(routeData.href, 'geocode');
    },
  },
  computed: {
    showGeo() {
      return this.geoState === 4;
    },
  },
};
</script>

<style lang="scss" scoped>
  .clickeable {
    cursor: pointer;
    :hover {
      animation: none;
      i { color: $fb-green; }
    }
    span {
      font-size: 8px;
      color: $fb-grey-light-50;
      margin: -8px -35px 0 14px;
      animation: jumps .5s infinite;
      .point-map {
        top: -3px;
        font-size: 10px;
        color: $fb-amber;
      }
    }
  }
  @keyframes jumps {
    0% { transform: translateY(0px); }
    50% { transform: translateY(4px); }
    100% { transform: translateY(0px); }
  }
</style>
